export const headerName = {
  dashboard: 'Dashboard',
  networksAndInternet: 'Networks and internet',
  serverErrorText: 'Server Error',
  mobile_plans_devices: 'Mobile plans and devices',
  trackRequests: 'Track requests',
  adaptiveNetworks: 'Adaptive networks',
  dataCenterCloud: 'Data centre cloud',
  yourServices: 'Your services',
  allServices: 'All services',
  readOnlyUser: 'READ_ONLY',
  manage: 'Manage',
  services: 'Services',
  searchMobileNumberLabel: 'Search mobile number',
  routeConstant: 'service-requests/v6',
  routeConstantv7: 'service-requests/v7',
  mobilitySolutions: 'mobility-solutions',
  incorrectMobileServiceContractEndDate: '2999-12-31',
  yourServiceRefBlockLabel: 'Your service reference',
  mobileServiceDetailPageCreateRequestButtonLabel: 'Create a request',
  reacSessionStorageName: 'reacSessionStorageName',
  deacSessionStorageName: 'deacSessionStorageName',
  networksAndInternetInt: 'Your services',
  plannedMaintenance: 'Planned maintenance',
  pmInsightMetricHeader: 'Upcoming planned maintenance',
  yourProductsAndServicesInt: 'Your products and services',
}

export const TO_FILTER_STATUS_MAPPING = {
  'Offline / unreachable': ['Issues'],
  'Active': ['Active', 'Optimal'],
  'Partially active / intermittent': ['Degraded', 'Intermittent'],
  'Idle': ['Idle'],
  'Planned maintenance': ['Planned Maintenance'],
}

export const STATUS_MAPPING = {
  'Optimal': 'Active',
  'Active': 'Active',
  'Issues': 'Offline / unreachable',
  'Intermittent': 'Partially active / intermittent (jitter)',
  'Degraded': 'Partially active / intermittent (jitter)',
  'No Data': 'No data available',
  'Idle': 'Idle',
  'N/A': '',
}

export const COLUMN_NAME_MAPPING = {
  'Site address': 'location',
  'Site ID': 'siteId',
  'Service ID': 'serviceId',
  'Connection ID': 'connectionId',
  'Your service reference': 'userReference',
  'Service type': 'serviceType',
  'Product name': 'productName',
  'Device name': 'deviceName',
  'Status': 'availabilityActivity',
  'LAN / Interface status': 'interfaceStatus',
  'Utilisation': 'utilisation',
  'Activity/Availability': 'availabilityActivity',
  'Activity': 'availabilityActivity',
  'Availability': 'availabilityActivity',
  'Errors': 'errors',
  'Tracking': 'tracking',
  'Billing Number': 'ban',
}
export const messages = {
  manageServicesMessage:
    `To make changes to a mobile service(s), select from the menu options under 'Manage' ` +
    `at right below. For other requests, select 'New request' below. We're making regular updates to this screen, ` +
    `so keep an eye out for new features.`,
  adaptiveMobilitymanageServicesMessage: `To make changes to a mobile service(s), select from the menu
  options under ‘Manage’ at right below. We’re making regular updates to this screen, so keep an eye out
  for new features. For all Adaptive Mobility or Corporate Mobile Plus services, select ‘Manage’ below.`,
  anotherRequest: 'New request',
  submissionSuccessToastMessage: (
    serviceNumber: string,
  ) => `Your request for ${serviceNumber} will be updated
    under its status below in the next few minutes.`,
  noMobileServices: 'There are currently no mobile services',
  adaptiveMobilityTooltipText: `Services include:

        Adaptive Mobility

        - Mobile Essential, Enhance and Epic

        - Mobile Broadband Essential,
        Enhanced and Epic

        - Enterprise Wireless Epic

        Corporate Mobile Plus

        Mobile and Broadband Local, National
        and Global plans with the option to
        BYO devices from us.`,
  apnGenericAlertMsg: 'This may not be the full list of available APN',
  noDataAvailable: 'No data available',
  tnAPNtitle: 'Access Point Name (APN) – select, change or remove',
  tnTONtitle: 'Manage Telstra One Number',
  voicemailSuccessMsg: 'Your voicemail request has been submitted',
  voicemailPending: {
    enablemessageBank: 'Pending - Enabling MessageBank®',
    enablevideoMessageBank: 'Pending - Enabling Video MessageBank®',
    enablemessageBankPlus: 'Pending - Enabling MessageBank® Plus for iPhone',
    enablevoice2Text: 'Pending - Enabling Voice2Text',
    disablemessageBank: 'Pending - Disabling MessageBank®',
    disablevideoMessageBank: 'Pending - Disabling Video MessageBank®',
    disablemessageBankPlus: 'Pending - Disabling MessageBank® Plus for iPhone',
    disablevoice2Text: 'Pending - Disabling Voice2Text',
    ringTime: 'Pending - Changing ring time',
    serviceArea: 'Pending - Changing mobile service area',
  },
  changeVoiceMailSuccessMsg: (
    voicemailType,
  ) => `Your request to change your voicemail to ${voicemailType}
     has been submitted`,
  noChangesToSave: 'No changes has been made to save',
  messageBankPlusBannerMsg: 'This option is for iPhones only',
  movedTimeZoneDesc: 'Change it here to make sure you get your local time stamp with messages.',
  somethingWentWrong: 'Something went wrong',
  tryAgain: 'try again',
}
export const messageBankModalContent = {
  changeToVoiceMessageBank: {
    header: 'Change to Voice MessageBank®?',
    bodyContent: [
      {
        value: 'Any saved messages for your current voicemail service will be deleted.',
        isBold: false,
      },
    ],
    size: 'medium',
    link: false,
    cancel: 'Cancel',
    enable: 'Yes, change',
  },
  disableMessageBank: {
    header: 'Disable MessageBank®?',
    bodyContent: [
      {
        value: 'By disabling MessageBank® any messages that have been saved will be deleted.',
        isBold: false,
      },
    ],
    size: 'small',
    link: false,
    cancel: 'Cancel',
    enable: 'Yes, disable',
  },
  enableVideoMessageBank: {
    header: 'Enable Video MessageBank® ?',
    bodyContent: [
      {
        value: 'Video MessageBank® requires data. Data barring also needs to be removed.',
        isBold: true,
      },
      {
        value:
          'For Video MessageBank® to work, this service needs data access. If this service is not on a plan,' +
          'pay-as-you-go data rates may apply.',
        isBold: false,
      },
      {
        value:
          'If data barring is enabled on this service, we will remove it so that Video MessageBank® can work.',
        isBold: false,
      },
      {
        value: 'To curb high mobile data usage, turn off mobile data in the phone’s settings.',
        isBold: false,
      },
    ],
    radioOptionsHeading: 'What would you like to do?',
    radioButtonOptionFastChange: 'Enable Video MessageBank® and remove any data barring',
    radioButtonOptionMaximChange:
      'Enable Video MessageBank®, remove any data barring and request help with' +
      ' mobile or data plan options',
    checkboxContent:
      'I agree to data being used for this service and any pay-as-you-go charges that may occur.',
    link: true,
    cancel: 'Cancel',
    enable: 'Proceed to enable',
    size: 'large',
  },
  changeToVideoMessageBank: {
    header: 'Change to Video MessageBank®?',
    bodyContent: [
      {
        value: 'Any saved messages for your current voicemail service will be deleted.',
        isBold: false,
      },
      {
        value: 'Video MessageBank® requires data. Data barring also needs to be removed.',
        isBold: true,
      },
      {
        value:
          'For Video MessageBank® to work, this service needs data access. If this ' +
          'service is not on a plan, pay-as-you-go data rates may apply.',
        isBold: false,
      },
      {
        value: `If data barring is enabled on this service, we will remove it so that
               Video MessageBank® can work.`,
        isBold: false,
      },
      {
        value: 'To curb high mobile data usage, turn off mobile data in the phone’s settings.',
        isBold: false,
      },
    ],
    radioOptionsHeading: 'What would you like to do?',
    radioButtonOptionFastChange: 'Enable Video MessageBank® and remove any data barring',
    radioButtonOptionMaximChange:
      'Enable Video MessageBank®, remove any data barring and request help with' +
      ' mobile or data plan options',
    link: true,
    checkboxContent:
      'I agree to data being used for this service and any pay-as-you-go charges that may occur.',
    cancel: 'Cancel',
    enable: 'Yes, change',
    size: 'large',
  },
  stpWarningText:
    'Before proceeding with this change, remember: If this service is not on a plan, pay-as-you-go' +
    ' data charges may apply.',
  radioButtonSelectionErrorMessage: 'You must select an option to continue',
  userAgreementCheckErrorMessage: 'You must agree to this to continue',
}
export enum GENERAL_FORM_DATA {
  FORM_NAME = 'GeneralRequest-Redux-Form',
  DEAC_WITHOUT_ETC_FAST_CHANGE = 'deactivate-without-etc-fastChange',
  DEAC_WITHOUT_ETC_REQUEST = 'deactivate-without-etc-request',
  DEAC_WITHOUT_ETC = 'deactivate-without-etc',
  DEAC_WITH_ETC = 'deactivate-with-etc',
  REACTIVATE = 'reactivate',
  REACTIVATE_PAST_DUE_DATE = 'reactivate-past-due-date',
  TEMPORARILY_SUSPEND_FAST_CHANGE = 'temporarily-suspend-fast-change',
}
